import { IRootReducerState } from "../../../redux-store/rootReducer";
import { IAuditLogPayload } from "../../../types/audit";
import { IBranch } from "../../../types/shared";
import { resolveActor } from "../utils/resolveActor";
import { AnyAction } from "redux";

export const buildDeleteBranchEntries = (
  action: AnyAction,
  state: IRootReducerState
): IAuditLogPayload[] => {
  const branch = action.payload as IBranch;
  if (!branch?.id) return [];

  const { actor, actor_type, accountManager, store } = resolveActor(state);

  return [
    {
      service_name: "order",
      action: "DELETE",
      actor,
      actor_type,
      service_type: "ordering",
      entity_type: "branch",
      entity_id: branch.id,
      entity_name: branch.name,
      change_area: "branch",
      before_state: branch as unknown as Record<string, unknown>,
      after_state: {},
      metadata: {
        account_manager: accountManager,
        parent_type: "store",
        parent_id: store.id,
        parent_name: store.name,
        parent_image: store.image,
      },
    },
  ];
};
